export default __webpack_public_path__ + "locales/lv/ConvertDialog.json?hash=8afea76cef2bf5f9a7f6657dbad60e23";